
import { Image } from "element-ui"
import inputNumber from "./input-number.vue"
import EllipsisItemList from "@/components/ellipsisItemList.vue"
import emptyImg from "@/assets/images/empty_img.png"
import { handleAddToCartV2 } from "@/utils/cartResponse"
import { showGlobalMessage, openNoAddressPop, formatWareImgUrl, noAddressCheck, getDeliveryMethod } from "@/utils/utils"
import { trackAddToCart, trackSelectItem, handleChangeCartNumber } from "@/utils/track"
import { handleChangeCartNumberOmnichat } from "@/utils/omnichat"
import addCartImg from "@/assets/images/addCart.png"
import disabledCart from "@/assets/images/disabledCart.png"
function getWareNumByCart(storeGroup) {
  let num = 0
  storeGroup.forEach(v => {
    num += Number(v.checkedCountWithoutGift)
  })
  return num
}

function getStockBySku(storeGroup, sku) {
  const cartList = []
  storeGroup.forEach(v => {
    v.wareGroup.forEach(_v => {
      if (_v.wares) {
        _v.wares.forEach(__v => {
          cartList.push({
            sku: __v.sku,
            stock: __v.stock
          })
        })
      }
    })
  })
  const item = cartList.find(v => v.sku === sku)
  const stock = item ? item.stock : 0
  return stock > 99 ? 99 : stock
}

export default {
  name: "WareViewWare",
  components: {
    [Image.name]: Image,
    inputNumber,
    EllipsisItemList
  },
  inject: {
    getStoreId: {
      default: null
    },
    source: {
      default: null
    },
    hideProTag: {
      default: false
    }
  },
  props: {
    defaultCount: {
      type: [String, Number],
      default: 0
    },
    config: {
      type: Object,
      default: () => ({
        wareImg: "",
        warePrice: "",
        wareName: ""
      })
    },
    btnIsDisabled: {
      type: Boolean,
      default: false
    },
    defaultMax: {
      type: Number,
      default: 99
    }
  },
  data() {
    return {
      clearInterval: null,
      info: {},
      addCart: addCartImg,
      disabledCart,
      itemElements: [],
      items: [],
      max: 99,
      count: 0,
      commonReqParams: {},
      deliveryMethod: "homeDelivery"
    }
  },
  computed: {
    showSoldTag() {
      return [1, 2].includes(this.info.wareStatus)
    },
    showProTag() {
      return (
        this.info.promotionWareVO.promotionInfoList &&
        this.info.promotionWareVO.promotionInfoList.length &&
        this.info.promotionWareVO.promotionInfoList[0].displayInfo &&
        this.info.promotionWareVO.promotionInfoList[0].displayInfo.proTag
      )
    },
    hasMutiProTag() {
      return (
        this.info.promotionWareVO.promotionInfoList &&
        this.info.promotionWareVO.promotionInfoList.length &&
        this.info.promotionWareVO.promotionInfoList.length > 1
      )
    },
    proDisplayTag() {
      return (
        this.info.promotionWareVO.promotionInfoList[0].displayInfo &&
        this.info.promotionWareVO.promotionInfoList[0].displayInfo.proTag
      )
    },
    imageUrl() {
      const imgUrl = this.info.wareImg
      if (imgUrl) {
        return formatWareImgUrl(imgUrl)
      }
      return emptyImg
    },
    detailLink() {
      return `${this.MAIN_ORIGIN}${this.MAIN_PATH}/productDetails?skuId=${this.info.sku}&name=${encodeURIComponent(
        this.info.wareName
      )}`
    }
  },
  watch: {
    defaultCount: {
      handler(newVal) {
        if (newVal !== 0) {
          this.count = newVal
        }
      },
      immediate: true
    },
    defaultMax: {
      handler(newVal) {
        this.max = newVal
      },
      immediate: true
    },
    config: {
      handler(newVal) {
        this.info = newVal
        if (newVal.promotionWareVO.promotionInfoList.length) {
          this.items = newVal.promotionWareVO.promotionInfoList.map(val => val.displayInfo.proTag)
        } else {
          this.items = []
        }
        // this.items = ['adsfadsfadsfe','32442432','32442432','32442432']
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    if (!process.client) {
      return
    }
    this.deliveryMethod = getDeliveryMethod()
    const { commonReqParams } = this.$commonParams
    this.storeId = this.getStoreId ? this.getStoreId() : commonReqParams.storeId
  },
  mounted() {},
  methods: {
    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    getNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    },
    getOmnichatParams() {
      const ware = this.info
      const category = this.info?.categoryArr?.[0] || ""
      return {
        id: `${ware.sku}`,
        name: ware.wareName || ware.name,
        brand: ware.brandName || "",
        category,
        variant: "",
        price:
          ware.promotionWareVO && ware.promotionWareVO.unitProPrice
            ? ware.promotionWareVO.unitProPrice / 100
            : ware?.promotionPrice
      }
    },
    // 输入框激活清除定时器
    handleFocus() {
      if (this.clearInterval) {
        this.clearInterval()
      }
    },
    // 失焦激活定时器
    handleBlur(count) {
      this.intervalChange({ ...this.info, addCartCount: count })
    },
    handleNumChange(val) {
      handleChangeCartNumberOmnichat(val, this.count, this.getOmnichatParams())
      handleChangeCartNumber(val, this.count, this.info)
      this.count = val

      if (val > 0) {
        this.intervalChange({ ...this.info, count: val })
      } else {
        if (this.clearInterval) {
          this.clearInterval()
          this.$emit(`goodsNummberShow`, { ...this.info, goodsNummberShow: false, count: val })
        }
      }
    },

    intervalChange(item) {
      const goodsItem = { ...item, goodsNummberShow: true }
      // 清理之前的定时器（如果有）
      if (this.clearInterval) {
        this.clearInterval()
      }
      // 启动新的定时器
      this.clearInterval = this.startCountdown(3, goodsItem)
    },
    // 定时器控制按钮的显示与隐藏
    startCountdown(seconds, goodsItem) {
      const that = this
      let countdown = seconds
      function update() {
        countdown--
        if (countdown < 0) {
          clearInterval(interval)
          that.$emit(`goodsNummberShow`, goodsItem)
        }
      }
      update() // 立即执行一次
      const interval = setInterval(update, 1000)
      // 返回一个清理函数，以便在需要时清除定时器
      return () => clearInterval(interval)
    },

    async handleAdd() {
      if (noAddressCheck()) {
        openNoAddressPop()
        return
      }

      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      const [error, data, wareList] = await handleAddToCartV2({
        storeId: this.storeId,
        wares: [{ sku: this.info.sku, beforeCount: 0, count: 1, checked: 1 }],
        sort: 1
      })
      if (error) {
        if (error.code == "44999") {
          openNoAddressPop()
        } else {
          // this.$message.error(error.result)
        }
      }
      if (data) {
        this.$bus.$emit("add-cart-success", this.source)
        if (this.source === "collect") {
          this.$bus.$emit("reload-collect")
        }
        this.count = 1
        this.intervalChange({ ...this.info, count: this.count })
      }
      if (wareList) {
        const item = wareList.find(v => v.skuId === this.info.sku)
        this.max = item && item.stock ? item.stock : 99
      }
      loading.close()
      trackAddToCart(this.info)
      handleChangeCartNumberOmnichat(1, 0, this.getOmnichatParams())
    },

    addCartBtn() {
      // 当有商品的时候，点击显示加减商品按钮
      this.$emit(`goodsNummberShow`, { ...this.info, goodsNummberShow: false })
      // 同时启动3秒定时器
      this.intervalChange(this.info)
    },
    trackSelectItem
  }
}
